import { Signal } from '@angular/core';
import { Area } from '@tourfold/libraries/tf-api-client-public-v2';
import { providePageContext } from '@tourfold/shared-kernels/page-context';

const MAX_VISIBLE_AREAS = 25;

export interface AreasAiPageContextSignals {
  readonly visibleAreas: Signal<readonly Area[]>;
  readonly searchQuery: Signal<string>;
  readonly editingArea: Signal<Area | null>;
}

/**
 * Surfaces the user's current focus on the Areas settings page so the AI assistant has the
 * minimum it needs to answer "what am I looking at?" — visible rows (label-only, no
 * geometry), the currently edited area (when the create/edit dialog is open), and the
 * search query. Geometry / file content is intentionally left out: it doesn't help the
 * assistant and rapidly bloats the context.
 */
export function provideAreasAiPageContext(state: AreasAiPageContextSignals): void {
  providePageContext(() => {
    const focused = state.editingArea();
    const search = state.searchQuery().trim();
    return {
      entity: focused
        ? {
            type: 'area',
            id: focused.id ?? '',
            label: focused.name ?? '',
          }
        : undefined,
      visible_rows: state
        .visibleAreas()
        .slice(0, MAX_VISIBLE_AREAS)
        .map((area) => ({
          type: 'area',
          id: area.id ?? '',
          label: area.name ?? '',
        })),
      filters: {
        ...(search.length > 0 && { search }),
      },
    };
  });
}
